<template>
  <a-row type="flex" justify="space-between">
    <a-col>
      <a-form layout="inline">
        <a-form-item>
          <a-input
            v-model:value="formState.search"
            class="form__item form__item--large"
            placeholder="Buscar..."
          >
            <template #prefix>
              <SearchOutlined />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item v-if="user?.customer?.type_business == 1">
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.selectedProfile"
            class="form__item"
          >
            <a-select-option :key="0">Todos los perfiles</a-select-option>
            <a-select-option v-for="profile in profiles" :key="profile.id">
              {{ profile.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-col>
    <a-col>
      <a-space class="buttonSection">
        <!-- <div class="flex">
          <div :style="{ marginLeft: `${buttonWidth}px`, clear: 'both', whiteSpace: 'nowrap' }">
            <a-popover placement="bottomLeft">
              <template #title>
                <h4 class="popover__title">Slot</h4>
              </template>

              <template #content>
                <p class="popover__content">
                  Los slots son la cantidad de usuarios disponibles que tienes para crear. Por
                  ejemplo, si tienes 10 slots, podrás crear como máximo 10 usuarios en {{ ProductName }}.
                </p>

                <a-button type="primary" class="button__slots">Comprar slots</a-button>
              </template>

              <InfoCircleOutlined />
            </a-popover>
          </div>
          <span> Slots disponibles: {{ userData?.customer?.slots }} </span>
        </div> -->
        <a-tooltip placement="left">
          <template #title v-if="!isClientBeexcc && (remainingSlots==0)">
            Comunícate con tu Partner para agregar más usuarios a tu equipo de trabajo.
          </template>
          <a-button type="primary" id="add-users-button" @click="handleShowModal" :disabled="!isClientBeexcc && (remainingSlots==0)">
            Agregar usuarios
          </a-button>
        </a-tooltip>

        <a-tooltip placement="topRight" :overlayStyle="{ width: '200px' }" arrowPointAtCenter>
          <template #title>
            <span v-if="isGlobalDownloading">Tiene una descarga pendiente</span>
            <span v-else> Descarga todos tus usuarios y su información. </span>
          </template>

          <a-button @click="handleDownload" :loading="downloading" :disabled="isGlobalDownloading">
            Descargar
            <DownloadOutlined />
          </a-button>
        </a-tooltip>

        <SelectUserCreationTypeModal
          v-model:visible="selectUserCreationTypeModalVisible"
          @click:invite="handleOpenInvite"
          @click:create="handleOpenCreate"
        />

        <users-invite-modal-create
          :key="keyIndex"
          v-if="visible"
          :visible="visible"
          :slotsInfo="slotsInfo"
          :isClientBeexcc="!isClientBeexcc"
          @back="handleShowModal"
          @update="$emit('update')"
          @onCloseModal="handleHideModal"
          @openBuyModal="$emit('openBuySlotsModal', $event)"
        />

        <UserGenerateModal
          v-if="createUserModalVisible"
          v-model:visible="createUserModalVisible"
          :slotsInfo="slotsInfo"
          :isClientBeexcc="!isClientBeexcc"
          @back="handleShowModal"
          @update="$emit('update')"
          @openBuyModal="$emit('openBuySlotsModal', $event)"
        />
      </a-space>
    </a-col>
  </a-row>
</template>

<script>
// import UsersModalCreate from "@/app/users/components/modals/UsersModalCreate";
import { defineComponent, ref, computed, inject } from "vue";
import { useStore } from "vuex";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons-vue";

import { downloadUsers } from "@/app/users/services";
import { downloadFile } from "@/app/shared/utils/file";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";

import UsersInviteModalCreate from "@/app/users/components/modals/UsersInviteModalCreate.vue";
import SelectUserCreationTypeModal from "@/app/users/components/modals/SelectUserCreationTypeModal.vue";
import UserGenerateModal from "@/app/users/components/modals/UserGenerateModal.vue";

export default defineComponent({
  components: {
    // UsersModalCreate,
    DownloadOutlined,
    SearchOutlined,
    SelectUserCreationTypeModal,
    UsersInviteModalCreate,
    UserGenerateModal,
  },
  props: {
    remainingSlots: Number,
    slotsInfo: Object,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const isClientBeexcc = computed(() => user.value?.is_beexcc);
    const { isGlobalDownloading } = useGlobalDownloadState();

    const selectUserCreationTypeModalVisible = ref(false);
    const createUserModalVisible = ref(false);

    const formState = inject("formState");

    return {
      user,
      buttonWidth: ref(70),
      formState,
      selectUserCreationTypeModalVisible,
      createUserModalVisible,
      isGlobalDownloading,
      isClientBeexcc,
    };
  },
  data() {
    return {
      selectedCampaign: 0,
      visible: false,
      enabled: true,
      keyIndex: 0,
      downloading: false,
    };
  },
  computed: {
    entities() {
      return this.$store.getters["getEntityList"];
    },
    portfolios() {
      return this.$store.getters["getFilteredPortfolios"];
    },
    profiles() {
      return this.$store.getters["getProfileList"];
    },
    userData() {
      return this.$store.getters["getDataUser"];
    },
  },
  mounted() {
    Promise.allSettled([
      this.$store.dispatch("fetchAllEntities"),
      this.$store.dispatch("fetchLoggedBusiness"),
      this.$store.dispatch("fetchAllProfiles"),
      this.$store.dispatch("fetchAllFilterProfile"),
    ]);
  },
  methods: {
    handleShowModal() {
      console.log(this.remainingSlots, 'this.remainingSlots');
      if (!this.remainingSlots || this.remainingSlots <= 0) {
        this.$emit("openBuySlotsModal");
        return;
      }
      this.selectUserCreationTypeModalVisible = true;
      this.handleHideModal();
    },
    handleOpenInvite() {
      this.visible = true;
    },
    handleOpenCreate() {
      this.createUserModalVisible = true;
    },
    handleHideModal() {
      this.keyIndex++;
      this.visible = false;
      this.createUserModalVisible = false;
      this.$store.dispatch("clearUser");
    },
    async handleDownload() {
      this.downloading = true;

      try {
        const response = await downloadUsers();
        const filename = `Usuarios.csv`;
        downloadFile(response, filename, { useResponseFileName: true });
      } catch (error) {
        const errorMessage = error?.getErrorMessage?.() || "Ha ocurrido un error";
        this.$message.error(errorMessage);
      }

      this.downloading = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.form
  &__item
    min-width: 180px

    &--large
      min-width: 260px
.buttonSection
  margin-top: 2.9px
  .ant-space-item:first-child
    margin-right: 12px !important
  .ant-space-item
    margin-right: 0px !important

.flex
  display: flex
  & span
    margin-left: 5px

#components-popover-demo-placement .ant-btn
  // width: 70px
  text-align: center
  padding: 0
  margin-right: 8px
  margin-bottom: 8px

.button__slots
  margin-top: 20px
  width: 100%
  height: 36px

.popover
  &__title
    font-size: 14px
    color: $gray-9
    font-weight: 600
    margin: 0

  &__content
    color: $gray-8
    margin: 0
    max-width: 220px
</style>
